import { Injectable } from '@angular/core';
import { Port } from '../models/port';
import { Device } from '../models/device';
import { PortClassification } from '../models/port-classification';
import { Subject, ReplaySubject } from 'rxjs';
import { Site } from '../models/Site';

@Injectable({
  providedIn: 'root'
})
export class SelectedElementsService {

  //consider, a standard approach to cleaning these up
  selectedPorts:Port[] = [];
  selectedDevices:Device[] = [];
  selectedPortClassifications:PortClassification[] = [];

  private _summaryHeading$ = new ReplaySubject<string>(1);
  public summaryHeading$ = this._summaryHeading$.asObservable();

  selectedRegion:number = -1;

  selectedSiteId:number;

  siteIdChangeSubject:Subject<Site> =  new Subject<Site>(); //just to track changes... there must be a better way possibly

  portDeviceSearchInput: String;

  setSummaryHeading(heading: string) {
    this._summaryHeading$.next(heading);
  }

  constructor() { }
}
